// extracted by mini-css-extract-plugin
export default {"InputText_Wrapper":"FormInputText_InputText_Wrapper__4Sr45","InputText_Input":"FormInputText_InputText_Input__WsXTF"};